import { GenericObject } from '@synergy/models';

/**
 * One document of a procurement chain (#2160).
 *
 * The type is the route segment the backend answers with ('purchase-orders',
 * 'invoices', …) rather than a DocumentType, because that is what both the link
 * and the stage of the view are built from.
 */
export class DocumentChainStep {
    public type!: string;
    public id!: number;
    public number: string | null = null;
    public status!: string;
    public netValue: number | null = null;
    public isCredit = false;
    public createdAt: string | null = null;
    /** The documents this one was made from, as "<type>:<id>". */
    public previous: string[] = [];
    public responsible: string | null = null;
    public supplier: string | null = null;
    public customer: string | null = null;
    public title: string | null = null;
    public messageCount = 0;

    public get key(): string {
        return `${this.type}:${this.id}`;
    }

    public static fromPlainObject(object: GenericObject): DocumentChainStep {
        const step = new DocumentChainStep();

        step.type = object['type'];
        step.id = object['id'];
        step.number = object['number'] ?? null;
        step.status = object['status'];
        step.netValue = object['netValue'] ?? null;
        step.isCredit = !!object['isCredit'];
        step.createdAt = object['createdAt'] ?? null;
        step.previous = object['previous'] ?? [];
        step.responsible = object['responsible'] ?? null;
        step.supplier = object['supplier'] ?? null;
        step.customer = object['customer'] ?? null;
        step.title = object['title'] ?? null;
        step.messageCount = object['messageCount'] ?? 0;

        return step;
    }
}
